import React, {Component} from 'react';
import {connect} from 'react-redux';


class Header extends Component {

  render() {
    const style = {
      background: '#000',
      boxShadow: 'none'
    }

    return (
      <header style={style} className="an-header">
        <a className="text-left user-name-header">{this.props.title ? this.props.title + ' |' : ''}</a>
        <a className="brand user-name-header">{this.props.userName}</a>
        <div className="header-right">
        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {
  return {
    colorHeaderBanner: state.headerBAnnerActiveStyle
  }
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/header.js